<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h1 class="mb-5">
              {{ `${isEdit ? "Edit" : "New"} Client-`
              }}<span class="primary--text"
                ><strong>{{
                  `${contactModel.firstName} ${contactModel.lastName}`
                }}</strong></span
              >
            </h1>
            <v-form ref="contactForm" @submit.prevent="save()">
              <v-row>
                <v-col>
                  <v-switch
                    class="mb-1 ml-2"
                    v-model="contactModel.profileStatus"
                    label="Inactive/Active"
                  />
                </v-col>
                <v-col>
                  <v-switch
                    class="mb-1 ml-2"
                    v-model="contactModel.managementCompany"
                    label="Managment Company"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-expansion-panels>
                  <!-- <v-expansion-panel>
                    <v-expansion-panel-header>
                      <h2>Personal Details</h2>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col md="6">
                          <v-text-field
                            label="First Name"
                            v-model="contactModel.firstName"
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            label="Last Name"
                            v-model="contactModel.lastName"
                            outlined
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="6">
                          <p class="display-2">
                            <strong>Assigned Title </strong>
                            {{ this.contactModel.title || "Not specified yet" }}
                          </p>
                          <base-title-picker
                            color="primary"
                            :label="'Title'"
                            :chosen-title.sync="contactModel.title"
                            :initial="contactModel.title"
                            v-model="contactModel.title"
                            outlined
                          />
                        </v-col>

                        <v-col md="6">
                          <p class="display-2">
                            <strong>Assigned rel. </strong>
                            {{
                              this.contactModel.relationship || "Not specified yet"
                            }}
                          </p>
                          <base-relationship-status-picker
                            :label="'Change Relationship Status'"
                            :initial="contactModel.relationship"
                            :chosen-relationship-status.sync="
                              contactModel.relationship
                            "
                            outlined
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="6">
                          <p class="display-2">
                            <strong>Assigned gender: </strong>
                            {{ this.contactModel.gender || "Not specified yet" }}
                          </p>
                          <base-gender-picker
                            :label="'Change Gender'"
                            :initial="contactModel.gender"
                            :chosen-gender.sync="contactModel.gender"
                            outlined
                          />
                        </v-col>

                        <v-col md="6">
                          <p class="display-2">
                            <strong>Assigned race: </strong>
                            {{ this.contactModel.race || "Not specified yet" }}
                          </p>
                          <base-race-picker
                            :label="'Change Race'"
                            :initial="contactModel.race"
                            :chosen-race.sync="contactModel.race"
                            outlined
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="12">
                          <p class="display-2">
                            <strong>Assigned Language: </strong>
                            {{ this.contactModel.language || "Not specified yet" }}
                          </p>
                          <base-language-picker
                            :label="'Choose Language'"
                            :initial="contactModel.language"
                            :chosen-language.sync="contactModel.language"
                            outlined
                          />
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel> -->
                  <!-- /// -->
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <h2>Personal Details</h2>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col md="6">
                          <v-text-field
                            label="First Name"
                            v-model="contactModel.firstName"
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            label="Last Name"
                            v-model="contactModel.lastName"
                            outlined
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="6">
                          <p class="display-2">
                            <strong>Assigned Title </strong>
                            {{ this.contactModel.title || "Not specified yet" }}
                          </p>
                          <base-title-picker
                            color="primary"
                            :label="'Title'"
                            :chosen-title.sync="contactModel.title"
                            :initial="contactModel.title"
                            v-model="contactModel.title"
                            outlined
                          />
                        </v-col>

                        <v-col md="6">
                          <p class="display-2">
                            <strong>Assigned rel. </strong>
                            {{
                              this.contactModel.relationship ||
                              "Not specified yet"
                            }}
                          </p>
                          <base-relationship-status-picker
                            :label="'Change Relationship Status'"
                            :initial="contactModel.relationship"
                            :chosen-relationship-status.sync="
                              contactModel.relationship
                            "
                            outlined
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="6">
                          <p class="display-2">
                            <strong>Assigned gender: </strong>
                            {{
                              this.contactModel.gender || "Not specified yet"
                            }}
                          </p>
                          <base-gender-picker
                            :label="'Change Gender'"
                            :initial="contactModel.gender"
                            :chosen-gender.sync="contactModel.gender"
                            outlined
                          />
                        </v-col>

                        <v-col md="6">
                          <p class="display-2">
                            <strong>Assigned race: </strong>
                            {{ this.contactModel.race || "Not specified yet" }}
                          </p>
                          <base-race-picker
                            :label="'Change Race'"
                            :initial="contactModel.race"
                            :chosen-race.sync="contactModel.race"
                            outlined
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="12">
                          <p class="display-2">
                            <strong>Assigned HQ: </strong>
                            {{
                              this.contactModel.hqName || "Not specified yet"
                            }}
                          </p>
                          <base-hq-name-picker
                            :label="'HQ name'"
                            :initial="contactModel.hqName"
                            :chosen-hq-name.sync="contactModel.hqName"
                            outlined
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="12">
                          <p class="display-2">
                            <strong>Contact Type: </strong>
                            {{
                              this.contactModel.contactTypeName ||
                              "Not specified yet"
                            }}
                          </p>
                          <base-contact-type-picker
                            :label="'Contact Type'"
                            :initial="contactModel.contactType"
                            :chosen-contact-type.sync="contactModel.contactType"
                            outlined
                          />
                        </v-col>

                        <v-col md="12">
                          <p class="display-2">
                            <strong>Tag: </strong>
                            {{
                              this.contactModel.tagName || "Not specified yet"
                            }}
                          </p>
                          <!-- <base-tag-picker
                            :label="'Tags'"
                            :initial="contactModel.tag"
                            :v-model="contactModel.tag"
                            :chosen-tag.sync="contactModel.tag"
                            solo
                            :isCreate="true"
                          /> -->
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="12">
                          <p class="display-2">
                            <strong>Contact Role: </strong>
                            {{
                              this.contactModel.contactRoleName ||
                              "Not specified yet"
                            }}
                          </p>
                          <base-contact-role-picker
                            :label="'Contact Role'"
                            :initial="contactModel.contactRole"
                            :chosen-contact-role.sync="contactModel.contactRole"
                            outlined
                            :isCreate="true"
                          />
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <!-- /// -->
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <h2>Contact Details</h2>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col md="6">
                          <v-text-field
                            label="Mobile"
                            v-model="contactModel.telNumber"
                            prefix="(+27)"
                            outlined
                          ></v-text-field
                        ></v-col>
                        <v-col md="6">
                          <v-text-field
                            label="Alternative Number"
                            v-model="contactModel.altNumber"
                            prefix="(+27)"
                            outlined
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col md="6"
                          ><v-text-field
                            label="Email"
                            v-model="contactModel.email"
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            label="Business email"
                            v-model="contactModel.businessEmail"
                            placeholder="someone@company.com"
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            label="Fax Number"
                            v-model="contactModel.faxNumber"
                            prefix="(+27)"
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            label="Postal Code"
                            v-model="contactModel.postalCode"
                            outlined
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="12">
                          <v-text-field
                            label="Region"
                            v-model="contactModel.region"
                            placeholder="Gauteng, JHB etc"
                            outlined
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-textarea
                            v-model="contactModel.bio"
                            outlined
                            counter
                            label="notes on client"
                            bio
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="mr-4" cols="12" sm="12" md="12">
                          <h2>Experience with contact Rating</h2>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-rating
                            v-model="contactModel.rating"
                            background-color="purple lighten-3"
                            half-increments
                            hover
                            length="5"
                            size="40"
                          ></v-rating>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <h2>Birth Details</h2></v-expansion-panel-header
                    >
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col md="6">
                          <v-col>
                            <div>
                              <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="contactModel.dob"
                                    label="Birthday date"
                                    prepend-inner-icon="mdi-calendar"
                                    readonly
                                    outlined
                                    v-bind="attrs"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="contactModel.dob"
                                  outlined
                                  :max="
                                    new Date(
                                      Date.now() -
                                        new Date().getTimezoneOffset() * 60000
                                    )
                                      .toISOString()
                                      .substr(0, 10)
                                  "
                                  min="1900-01-01"
                                  @change="saveDob"
                                ></v-date-picker>
                              </v-menu>
                            </div>
                          </v-col>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            label="Age"
                            class="mt-3"
                            v-model="contactModel.age"
                            outlined
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="12">
                          <v-text-field
                            label="ID Number/ Passport"
                            v-model="contactModel.idNumber"
                            outlined
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <h2>Address details</h2>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12" md="12" sm="12">
                          <v-textarea
                            label="Address"
                            outlined
                            counter
                            v-model="contactModel.fullAddress"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="12" sm="12">
                          <v-textarea
                            label="Postal Address"
                            outlined
                            counter
                            v-model="contactModel.postalAddress"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="6">
                          <v-text-field
                            label="Postal Code"
                            v-model="contactModel.postalCode"
                            outlined
                          ></v-text-field>
                        </v-col>

                        <v-col md="6">
                          <p>Region : {{ contactModel.region }}</p>
                          <base-region-picker
                            :label="'Region'"
                            solo
                            background-color="white"
                            color="black"
                            v-model="regionPicked"
                            :initial="contactModel.region"
                            :chosen-region.sync="contactModel.region"
                            outlined
                          />
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-row>

              <v-row>
                <v-col class="mr-6"> </v-col>
              </v-row>

              <v-row>
                <v-col class="mr-6 my-4">
                  <h2>Assigned Tags</h2>
                </v-col>
              </v-row>

              <v-row>
                <v-col md="6">
                  <p class="mb-12">
                    <strong>Assigned Branch: </strong>
                    {{ this.contactModel.branchName || "Not assigned yet" }}
                  </p>
                  <branch-picker
                    :label="'Re-assign your branch'"
                    :initial="contactModel.branch"
                    :chosen-branch.sync="contactModel.branch"
                    outlined
                  />
                </v-col>

                <v-col md="6">
                  <p class="mb-4">
                    <strong>Assigned Role: </strong>
                  </p>
                  <v-select
                    v-model="contactModel.role"
                    v-if="roles && roles.roles"
                    item-text="name"
                    label="Role"
                    class="mt-12"
                    :items="roles.roles"
                    outlined
                  ></v-select>
                </v-col>
                <v-col md="12">
                  <p class="display-2">
                    <strong>Assigned industry: </strong>
                    {{ this.contactModel.industry || "Not specified yet" }}
                  </p>
                  <industry-picker
                    :label="'Change your industry'"
                    :initial="contactModel.industry"
                    :chosen-industry.sync="contactModel.industry"
                    outlined
                  />
                </v-col>
                <v-col md="12">
                  <p class="display-2">
                    <strong>Assigned Consultant: </strong>
                    {{
                      this.contactModel.consultantName || "Not specified yet"
                    }}
                  </p>
                  <contact-edit-picker
                    :label="'Assigned Consultant'"
                    :initial="contactModel.consultant"
                    :chosen-contact.sync="contactModel.consultant"
                    :role="'consultant'"
                    outlined
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col md="12">
                  <p class="display-2">
                    <strong>Referral source: </strong>
                    {{ this.contactModel.referral || "Not specified yet" }}
                  </p>
                  <referral-picker
                    :label="'Where the lead came from'"
                    :initial="contactModel.referral"
                    :chosen-referral.sync="contactModel.referral"
                    outlined
                  />
                </v-col>
                <v-col md="12">
                  <v-text-field
                    label="Lead Reference Number"
                    v-model="contactModel.referralNumber"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12">
                  <v-text-field
                    label="Mailing preference"
                    v-model="contactModel.mailingPref"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <p class="display-2">
                    <strong>Last Updated By: </strong>
                    {{ this.contactModel.updatedByName || "Not specified yet" }}
                  </p>
                </v-col>
              </v-row>
              <v-row>
                <v-spacer></v-spacer>
                <base-password-reset-modal />
                <v-spacer></v-spacer>
                <v-col class="text-right">
                  <v-btn type="submit" color="success" class="text-align-right">
                    <h1>Save</h1>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- <v-col md="6" v-if="contactModel.id">
        <v-card>
          <v-card-text> -->
      <!-- <base-material-tabs color="secondary" class="my-5" grow>
              <v-tab v-for="(tab, i) in tabs" :key="i">
                {{ tab }}
              </v-tab>
              <v-tab-item>
                <v-col cols="12" sm="12" md="12" xl="12" v-if="contactModel.id">
                  <v-card>
                    <v-card-text>
                      <h4 class="text-md-h4 primary--text mb-5">
                        Event TimeLine
                      </h4>
                      <contact-event-time-line
                        :contactId="contactModel.id"
                        :consultantId="contactModel.consultant"
                      />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-tab-item>

              <v-tab-item>
                <h4 class="text-md-h4 primary--text my-5">Edit Events</h4>
                <contact-events
                  :contactId="contactModel.id"
                  :consultantId="contactModel.consultant"
                />
              </v-tab-item>
            </base-material-tabs> -->
      <!-- </v-card-text> -->
      <!-- </v-card> -->
      <!-- </v-col> -->
    </v-row>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import { User } from "@/models/User";
import IndustryPicker from "../../../components/Base/Pickers/IndustryPicker.vue";

export default {
  components: {
    IndustryPicker,
  },
  name: "EditUser",
  data() {
    return {
      tab: 0,
      tabs: ["View Timeline", "Edit Events"],
      isEdit: false,
      isLoading: false,
      contactModel: new User(),
      menu: false,
      date: null,
      search: "",
      dialog3: false,
      totalRecords: 0,
      id: "",
      crumbs: [
        {
          text: "Clients",
          disabled: false,
          href: "/admin/contacts",
        },
        {
          text: "Client Detail",
          disabled: false,
          href: `/admin/contact/${this.$route.params.id}`,
        },
        {
          text: `${this.isEdit ? "Edit" : "New"} Client`,
          disabled: true,
        },
      ],

      me: "",
      headers: [
        {
          text: "Explanation",
          align: "start",
          sortable: false,
          value: "explanation",
        },

        { text: "Created Date", value: "createdAt", align: "left" },
        { text: "Actions", align: "left", sortable: false, value: "actions" },
      ],
    };
  },
  created() {
    this.isEdit = this.$route.params.id != 0;
    this.isLoading = this.isEdit ? true : false;
  },
  computed: {},

  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,

    contact: {
      query: gql`
        query User($id: ID!) {
          contact(id: $id) {
            id
            firstName
            lastName
            title
            relationship
            gender
            race
            telNumber
            altNumber
            email
            businessEmail
            faxNumber
            bio
            rating
            age
            dob
            idNumber
            passport
            fullAddress
            language
            postalAddress
            role
            referral
            branch
            branchName
            consultant
            consultantName
            postalCode
            region
            regionName
            mailingPref
            companyName
            referralNumber
            updatedBy
            updatedByName
            profileStatus
            hqName
            hqName_text
            organisation
            organisationName
            contactType
            contactTypeName
            contactRole
            contactRoleName
            tag
            tagName
            industry
            industryName
            managementCompany
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.isEdit;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      result(response, key) {
        this.isLoading = false;
        this.contactModel.id = this.contact.id;
        this.contactModel.firstName = this.contact.firstName;
        this.contactModel.lastName = this.contact.lastName;
        this.contactModel.title = this.contact.title;
        this.contactModel.relationship = this.contact.relationship;
        this.contactModel.gender = this.contact.gender;
        this.contactModel.race = this.contact.race;
        this.contactModel.telNumber = this.contact.telNumber;
        this.contactModel.altNumber = this.contact.altNumber;
        this.contactModel.email = this.contact.email;
        this.contactModel.businessEmail = this.contact.businessEmail;
        this.contactModel.faxNumber = this.contact.faxNumber;
        this.contactModel.rating = this.contact.rating;
        this.contactModel.bio = this.contact.bio;
        this.contactModel.dob = this.contact.dob;
        this.contactModel.age = this.contact.age;
        this.contactModel.idNumber = this.contact.idNumber;
        this.contactModel.passport = this.contact.passport;
        this.contactModel.fullAddress = this.contact.fullAddress;
        this.contactModel.postalAddress = this.contact.postalAddress;
        this.contactModel.language = this.contact.language;
        this.contactModel.industry = this.contact.industry;
        this.contactModel.role = this.contact.role;
        this.contactModel.referral = this.contact.referral;
        this.contactModel.referralNumber = this.contact.referralNumber;
        this.contactModel.consultant = this.contact.consultant;
        this.contactModel.consultantName = this.contact.consultantName;
        this.contactModel.branch = this.contact.branch;
        this.contactModel.branchName = this.contact.branchName;
        this.contactModel.postalCode = this.contact.postalCode;
        this.contactModel.region = this.contact.region;
        this.contactModel.regionName = this.contact.regionName;
        this.contactModel.mailingPref = this.contact.mailingPref;
        this.contactModel.companyName = this.contact.companyName;
        this.contactModel.updatedBy = this.contact.updatedBy;
        this.contactModel.updatedByName = this.contact.updatedByName;
        this.contactModel.profileStatus = this.contact.profileStatus;
        this.contactModel.hqName = this.contact.hqName;
        this.contactModel.hqName_text = this.contact.hqName_text;
        this.contactModel.organisation = this.contact.organisation;
        this.contactModel.organisationName = this.contact.organisationName;
        this.contactModel.contactType = this.contact.contactType;
        this.contactModel.contactTypeName = this.contact.contactTypeName;
        this.contactModel.contactRole = this.contact.contactRole;
        this.contactModel.contactRoleName = this.contact.contactRoleName;
        this.contactModel.tag = this.contact.tag;
        this.contactModel.tagName = this.contact.tagName;
        this.contactModel.industry = this.contact.industry;
        this.contactModel.industryName = this.contact.industryName;
        this.contactModel.managementCompany = this.contact.managementCompany;
      },
    },

    roles: {
      query: gql`
        query {
          __type(name: "Role") {
            roles: enumValues {
              name
            }
          }
        }
      `,
      update: (data) => data.__type,
    },
    eventStatuses: {
      query: gql`
        query {
          __type(name: "EventStatus") {
            eventStatuses: enumValues {
              name
            }
          }
        }
      `,
      update: (data) => data.__type,
    },
  },
  methods: {
    saveDob(date) {
      this.$refs.menu.save(date);
    },
    async save() {
      this.isLoading = true;
      const self = this;
      if (!self.$refs.contactForm.validate()) {
        self.$swal("Error", "Validation failed", "error");

        self.isLoading = false;
        return;
      }
      if (self.isEdit) {
        await this.updateUser()
          .then(() => {
            this.$swal("Success!", "The contact was was updated", "success");
            window.location.href = `/admin/contacts`;
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              "something went wrong when trying to update the contact, check data and try again later!",
              "error"
            );
          });
      } else {
        await this.createUser()
          .then(() => {
            this.$swal("Success!", "The contact was created", "success");
            window.location.href = `/admin/contacts`;
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              `Something went wrong when creating the contact, check data and try again later!`,
              "error"
            );
          });
      }
      this.isLoading = false;
    },
    async updateUser() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation updateUser($contact: UserUpdateInput!) {
              updateUser(contact: $contact) {
                id
                updated
              }
            }
          `,
          variables: {
            contact: {
              id: self.$route.params.id,
              firstName: self.contactModel.firstName,
              lastName: self.contactModel.lastName,
              title: self.contactModel.title,
              relationship: self.contactModel.relationship,
              language: self.contactModel.language,
              gender: self.contactModel.gender,
              race: self.contactModel.race,
              telNumber: self.contactModel.telNumber,
              altNumber: self.contactModel.altNumber,
              email: self.contactModel.email,
              businessEmail: self.contactModel.businessEmail,
              faxNumber: self.contactModel.faxNumber,
              region: self.contactModel.region,
              regionName: self.contactModel.regionName,
              postalCode: self.contactModel.postalCode,
              bio: self.contactModel.bio,
              rating: self.contactModel.rating,
              dob: self.contactModel.dob,
              idNumber: self.contactModel.idNumber,
              passport: self.contactModel.passport,
              fullAddress: self.contactModel.fullAddress,
              postalAddress: self.contactModel.postalAddress,
              industry: self.contactModel.industry,
              role: self.contactModel.role,
              referral: self.contactModel.referral,
              referralNumber: self.contactModel.referralNumber,
              branch: self.contactModel.branch,
              consultant: self.contactModel.consultant,
              mailingPref: self.contactModel.mailingPref,
              companyName: self.contactModel.companyName,
              profileStatus: self.contactModel.profileStatus,
              hqName: self.contactModel.hqName,
              updatedBy: self.me.id,
              organisation: self.contactModel.organisation,
              contactType: self.contactModel.contactType,
              contactRole: self.contactModel.contactRole,
              tag: self.contactModel.tag,
              industry: self.contactModel.industry,
              managementCompany: self.contactModel.managementCompany,
            },
          },
        });
        if (!response) {
          throw "Something went wrong when creating the contact!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
      } catch (e) {
        throw e.message;
      }
    },
    async createUser() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation createUser($contact: UserCreateInput!) {
              createUser(contact: $contact) {
                id
              }
            }
          `,
          variables: {
            contact: {
              firstName: self.contactModel.firstName,
              lastName: self.contactModel.lastName,
              title: self.contactModel.title,
              relationship: self.contactModel.relationship,
              language: self.contactModel.language,
              gender: self.contactModel.gender,
              race: self.contactModel.race,
              telNumber: self.contactModel.telNumber,
              altNumber: self.contactModel.altNumber,
              email: self.contactModel.email,
              businessEmail: self.contactModel.businessEmail,
              faxNumber: self.contactModel.faxNumber,
              bio: self.contactModel.bio,
              rating: self.contactModel.rating,
              dob: self.contactModel.dob,
              idNumber: self.contactModel.idNumber,
              passport: self.contactModel.passport,
              fullAddress: self.contactModel.fullAddress,
              postalAddress: self.contactModel.postalAddress,
              industry: self.contactModel.industry,
              role: self.contactModel.role,
              referral: self.contactModel.referral,
              referralNumber: self.contactModel.referralNumber,
              branch: self.contactModel.branch,
              consultant: self.contactModel.consultant,
              postalCode: self.contactModel.postalCode,
              region: self.contactModel.region,
              regionName: self.contactModel.regionName,
              mailingPref: self.contactModel.mailingPref,
              companyName: self.contactModel.companyName,
              profileStatus: self.contactModel.profileStatus,
              hqName: self.contactModel.hqName,
              hqName: self.contactModel.hqName_text,
              contactRole: self.contactModel.contactRole,
              managementCompany: self.contactModel.managementCompany,
            },
          },
        });
        if (!response) {
          throw "Something went wrong when creating the Client!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
        if (response && response.data.createUser) {
          self.contactModel.id = response?.data?.createUser?.id;
        }
      } catch (e) {
        throw e.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
